import { HAS_END_CUSTOMER } from "~/utils/constants";

export const getInitialPriceReference = () => {
  if (HAS_END_CUSTOMER) {
    return window.SCHA.config.priceReferences[1].value;
  }
  return "";
};
